import AudienceContacts from "./AudienceContacts.vue";

export * from "./audienceContacts.data";
export * from "./audienceContacts.types";

export default AudienceContacts;
